import {persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {Action} from '../../types/redux';
import types, {licenseKey} from './types';
import {ILicense} from '../../types/License';
import {ILicenseOptionsResponse} from '../../types/LicenseOptionsResponse';
import {injectEntitlments} from 'redux/license/utils';

export const licenseInitialState = {
   license: {} as ILicense,
   options: {} as ILicenseOptionsResponse,
   isFetching: false,
   error: null,
};

const reducer = (state = licenseInitialState, action: Action) => {
   switch (action.type) {
      case types.GET_LICENSE.REQUEST:
         return {
            ...state,
            license: {} as ILicense,
            isFetching: true,
            error: null,
         };
      case types.GET_LICENSE_OPTIONS.REQUEST:
         return {
            ...state,
            options: {},
            isFetching: true,
            error: null,
         };
      case types.GET_LICENSE.ERROR:
      case types.GET_LICENSE_OPTIONS.ERROR:
         return {
            ...state,
            isFetching: false,
            isAuthenticated: false,
            error: action.payload,
         };
      case types.GET_LICENSE.SUCCESS:
         return {
            ...state,
            license: injectEntitlments(action.payload),
            isFetching: false,
            error: null,
         };
      case types.GET_LICENSE_OPTIONS.SUCCESS:
         return {
            ...state,
            options: action.payload,
            isFetching: false,
            error: null,
         };
      default:
         return state;
   }
};

let _reducer = reducer;
const config = {
   key: licenseKey,
   storage: storage,
   blacklist: ['error', 'isFetching'],
};
_reducer = persistReducer(config, reducer) as any;

export default _reducer;
